<template>
  <span
    v-if="showSelectOffice"
    class="w-100"
  >
    <b-col
      v-if="localDataLoad"
      cols="12"
      class="d-flex align-items-center justify-content-center"
    >
      <b-spinner label="Loading..." />
    </b-col>
    <b-form-group
      v-if="!localDataLoad"
    >
      <b-form-select
        :key="optionsWithPlaceholder.length"
        v-model="office_id"
        :options="optionsWithPlaceholder"
        value-field="value"
        text-field="text"
        trim
        @change="handleOffice"
      />
    </b-form-group>
  </span>
</template>

<script>
export default {
  props: {
    showSelectOffice: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const q = this.$route.query.office
    return {
      office_id: q !== undefined && q !== null && q !== '' ? q : '',
      localDataLoad: false,
    }
  },

  computed: {
    optionsOffice() {
      return this.$store.getters['generalData/offices/offices']
    },
    optionsWithPlaceholder() {
      const offices = this.optionsOffice || []
      const placeholder = { value: '', text: 'Select Office', disabled: true }
      return [placeholder, ...offices]
    },
  },

  watch: {
    /* eslint-disable */
    '$route.query.office'(val) {
      this.office_id = val !== undefined && val !== null && val !== '' ? val : ''
    },
  },

  async mounted() {
    if (this.showSelectOffice) {
      if (!this.$store.getters['generalData/offices/officesLoaded']) {
        this.localDataLoad = true
        await this.$store.dispatch('generalData/offices/fetchOffices')
        this.localDataLoad = false
      }
    }

    // Ensure placeholder shows when no office in URL
    if (this.$route.query.office == null || this.$route.query.office === '') {
      this.office_id = ''
    }
  },
  methods: {
    handleOffice() {
      this.$router.push({
        query: { ...this.$route.query, office: this.office_id },
      })
    },
  },
}
</script>
